import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter } from 'react-router';
import { ModalsProvider } from 'store/contexts/ModalContext/ModalContext.provider';
import { FiltersProvider } from 'store/contexts/FiltersContext/FiltersContext.provider';
import { Provider } from 'react-redux';
import { store } from 'store/store';
import './index.styles.scss';
import { LocalizationProvider } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <LocalizationProvider>
        <ModalsProvider>
          <BrowserRouter>
            <FiltersProvider>
              <App />
            </FiltersProvider>
          </BrowserRouter>
        </ModalsProvider>
      </LocalizationProvider>
    </Provider>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
